import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import {
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown
} from 'reactstrap';
import { Link } from 'react-router-dom';
import axiosInstance from '@src/axios-instance';
import { withRouter } from 'react-router';

import UnitInformation from './UnitInformation/UnitInformation';
import EOISList from './EOISList/EOISList';
import UnitsModal from '@src/components/Associations/AssociationView/Addresses/Units/UnitsModal/UnitsModal';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';
import EvidenceOfInsuranceModal from '@components/EvidenceOfInsurance/EvidenceOfInsuranceModal/EvidenceOfInsuranceModal';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';

class UnitView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      loading: false,
      entity: {},
      editUnitInformationModal: false,
      editHomeownersModal: false,
      editMortgagesModal: false,
      editMailingAddressModal: false,
      evidenceOfInsuranceModal: false,
      confirmModalActive: false,
      pagination: {
        sort: 'EvidenceOfInsurances.issue_date',
        direction: 'DESC'
      }
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.getEntity(this.props.id);
  }

  toggleModal = (modalType, eoiId) => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType],
      eoiId: eoiId !== undefined ? eoiId : null
    }));
  };

  getEntity = (entityId, direction) => {
    this.setState({ loading: true });
    axiosInstance()
      .get(`/units/${entityId}.json`, {
        params: { order: direction }
      })
      .then(response => {
        this.setState({
          loaded: true,
          entity: response.data,
          pagination: {
            sort: 'EvidenceOfInsurances.issue_date',
            direction: direction
          }
        });
        this.setState({ loading: false });
      })
      .catch(err => {
        this.setState({ loading: false });
      });
  };

  onEvidenceClick = entityId => {
    this.props.history.push(`/eois/${entityId}`);
  };

  onUpdate = (postData, callback, modalType) => {
    this.setState({ loading: true });
    axiosInstance()
      .put(`/units/${this.state.entity.id}.json`, postData)
      .then(response => {
        if (modalType !== undefined) {
          this.toggleModal(modalType);
        }
        this.setState({
          entity: response.data,
          loading: false
        });
        callback();
      })
      .catch(err => {
        this.setState({
          loading: false
        });
      });
  };

  onRemove = () => {
    axiosInstance()
      .delete(`/units/${this.state.entity.id}.json`)
      .then(response => {
        this.props.history.push(
          `/associations/${this.state.entity.association_id}`
        );
      })
      .catch(err => {});
  };

  render = () => {
    const { entity } = this.state;
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Units</title>
        </Helmet>
        {this.state.loaded && (
          <React.Fragment>
            {this.state.loading && (
              <ProgressBox
                text={'Loading ...'}
                loader={'transparent-background'}
              />
            )}
            <div>
              <Breadcrumb className={'pt-0'} listClassName={'pt-0 pl-0'}>
                <BreadcrumbItem>
                  <Link to={'/associations'}>Associations</Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to={`/associations/${entity.association.id}`}>
                    {entity.association.name}
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                  {entity.address_no} {entity.street} {entity.unit_no}
                </BreadcrumbItem>
              </Breadcrumb>
            </div>
            <div>
              <Link
                to={`/associations/${entity.association.id}`}
                className={'font-lg text-break'}
              >
                &lsaquo; Back to {entity.association.name}
              </Link>
              <Auth action={'Associations::editUnit'}>
                <UncontrolledDropdown className={'float-right'}>
                  <DropdownToggle caret>Actions</DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem
                      onClick={() =>
                        this.toggleModal('evidenceOfInsuranceModal')
                      }
                      disabled={entity.common_area_only}
                    >
                      Create EOI
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => this.toggleModal('confirmModalActive')}
                    >
                      Delete Units
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Auth>
            </div>
            <div className={'clear'}>&nbsp;</div>
            <Row className={'mb-2'}>
              <Col>
                <UnitInformation
                  entity={entity}
                  toggle={() => this.toggleModal('editUnitInformationModal')}
                />
              </Col>
            </Row>
            <Row className={'mb-2'}>
              <Col>
                <EOISList
                  {...this.state.pagination}
                  paginationFunc={params =>
                    this.getEntity(this.props.id, params.direction)
                  }
                  entities={entity.evidence_of_insurances}
                  onEntityClick={this.onEvidenceClick}
                  onCreateClick={itemId =>
                    this.toggleModal('evidenceOfInsuranceModal', itemId)
                  }
                />
              </Col>
            </Row>

            <UnitsModal
              entity={entity}
              isActive={this.state.editUnitInformationModal}
              toggle={() => this.toggleModal('editUnitInformationModal')}
              totalPhase={entity.association.total_phase}
              onSubmit={(postData, callback) =>
                this.onUpdate(postData, callback, 'editUnitInformationModal')
              }
              errorUnit={this.state.errorUnit}
            />
            <ConfirmModal
              isActive={this.state.confirmModalActive}
              toggle={() => this.toggleModal('confirmModalActive')}
              body={
                'Please confirm to delete this unit. All EOIs related to this unit will also be deleted from the' +
                ' database.'
              }
              confirmLabel={'Yes, delete this unit and related EOIs'}
              confirmAction={this.onRemove}
            />
            <EvidenceOfInsuranceModal
              entity={entity}
              isActive={this.state.evidenceOfInsuranceModal}
              toggle={() => this.toggleModal('evidenceOfInsuranceModal')}
              eoiId={this.state.eoiId}
              history={this.props.history}
              loader={loading => this.setState({ loading: loading })}
            />
          </React.Fragment>
        )}
      </Container>
    );
  };
}
export default withRouter(UnitView);
